import { Tooltip2 } from '@tencent/udesign/dist';
import classNames from 'classnames';
import { SORT_ASC_TEXT, SORT_CANCEL_TEXT, SORT_DES_TEXT } from '../libs';
import { ITableColumn, ITableSortValue, TableSortAction } from '../model';

interface IProps<T> {
  readonly columnIndex: number;
  readonly column: ITableColumn<T>;
  readonly sortValue: ITableSortValue | null;
  readonly setSortValue: (
    value: ITableSortValue | null,
    column: ITableColumn<T>
  ) => void;
  readonly sortable: boolean | 'custom';
  readonly sorter?: (a: T, b: T) => number;
  readonly sortLoading: boolean;
}

// 列排序
export function ColumnSortComponent<T>(props: IProps<T>) {
  const { key } = props.column;
  const order = props.sortValue?.order;
  const isDes = order === TableSortAction.descending; // 是否降序
  const isAsc = order === TableSortAction.ascending; // 是否升序

  // 默认是空 -> 升序 -> 降序 -> 空
  const getNextOrderAction = () => {
    // 当前排序的字段跟现在排序的字段一致
    if (props.sortValue?.key === key) {
      if (isAsc) {
        return TableSortAction.descending;
      }
      if (isDes) {
        return undefined;
      }
    }
    return TableSortAction.ascending;
  };

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (props.sortLoading) {
      return;
    }
    props.setSortValue(
      {
        key,
        order: getNextOrderAction(),
      },
      props.column
    );
  };

  const renderTipText = () => {
    if (order === undefined) {
      return SORT_ASC_TEXT;
    }
    if (isAsc) {
      return SORT_DES_TEXT;
    }
    return SORT_CANCEL_TEXT;
  };

  const renderBtn = (order?: TableSortAction) => {
    const className = classNames('table-sort', order, {
      disabled: props.sortLoading,
    });
    return (
      <div className={className} onClick={onClick}>
        <span className="sort-ascending"></span>
        <span className="sort-descending"></span>
      </div>
    );
  };

  if (props.sortValue?.key !== key) {
    return (
      <div className="cell-sort">
        <Tooltip2 title={SORT_ASC_TEXT}>{renderBtn()}</Tooltip2>
      </div>
    );
  }

  return (
    <div className="cell-sort">
      <Tooltip2 title={renderTipText()}>{renderBtn(order)}</Tooltip2>
    </div>
  );
}
